import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useAccordionButtonStyles = makeStyles({
  root: {
    ...shorthands.padding(0),
  },
  icon: {
    transform: 'rotate(0deg)',
    ...shorthands.transition('transform', tokens.durationNormal, '0s', tokens.curveDecelerateMax),
  },
  iconCollapsed: {
    transform: 'rotate(-180deg)',
  },
});
